import { useState, useMemo } from "react";
import { Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";
import { loc } from "@/lib/localize";

export default function SearchBar() {
  const { t, lang } = useLang();
  const { content } = useContent();
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [country, setCountry] = useState("");

  const services = content?.services || [];
  const countries = useMemo(
    () => [...(content?.countries_primary || []), ...(content?.countries_secondary || [])],
    [content]
  );

  const onSearch = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (serviceType) params.set("service", serviceType);
    if (country) params.set("country", country);
    navigate(`/services?${params.toString()}`);
  };

  return (
    <section className="relative -mt-16 z-20 px-4 sm:px-6 lg:px-8" data-testid="search-section">
      <div className="max-w-6xl mx-auto">
        <form
          onSubmit={onSearch}
          className="glass rounded-2xl p-6 sm:p-8 gold-glow border border-[var(--gold)]/20"
          data-testid="search-form"
        >
          <h3 className="font-display text-xl sm:text-2xl font-bold text-white mb-5">
            {t("search.title")}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-3">
            <div className="md:col-span-5 relative">
              <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[var(--gold)]" />
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder={t("search.placeholder")}
                className="input-dark pl-11"
                data-testid="search-input"
              />
            </div>
            <div className="md:col-span-3">
              <select
                value={serviceType}
                onChange={(e) => setServiceType(e.target.value)}
                className="input-dark"
                data-testid="search-service"
              >
                <option value="">{t("search.service")}: {t("search.any")}</option>
                {services.map((s) => (
                  <option key={s.id} value={s.id}>{loc(s.title, lang)}</option>
                ))}
              </select>
            </div>
            <div className="md:col-span-2">
              <select
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                className="input-dark"
                data-testid="search-country"
              >
                <option value="">{t("search.country")}: {t("search.any")}</option>
                {countries.map((c) => (
                  <option key={c.code} value={c.code}>{c.name}</option>
                ))}
              </select>
            </div>
            <div className="md:col-span-2">
              <button type="submit" className="btn-gold w-full justify-center" data-testid="search-submit">
                <Search size={15} /> {t("search.search")}
              </button>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
}
